import { Injectable } from '@angular/core';
import { Store, StoreConfig } from '@datorama/akita';
import { IStatesState } from 'sustainment-component';

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'stateInfo' })
export class StateStore extends Store<IStatesState> {
  public constructor() {
    super({});
  }
}
